import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
import auth from "./modules/auth";
import user from "./modules/user";
import customer from "./modules/customer";
import product from "./modules/product";
import order from "./modules/order";
import retur from "./modules/retur";
import termofservice from "./modules/termofservice";
import category from "./modules/category";
import alert from "./modules/alert";
import orderdisplay from "./modules/orderDisplay";
import principal from "./modules/principal";
import brand from "./modules/brand";
import branch from "./modules/branch";
import promo from "./modules/promo";
import paymentType from "./modules/paymentType";
import banner from "./modules/banner";
import ppn from "./modules/ppn";
import customerNew from "./modules/customerNew";
import conversionPoint from "./modules/conversionPoint";
import loyaltyItem from "./modules/loyaltyItem";
import area from "./modules/area";
import pushcartProduct from "./modules/pushcartProduct";
import resetPassword from "./modules/resetPassword";
import report from "./modules/report";
import shoppingCart from "./modules/shoppingCart";
import loyaltyPurchase from "./modules/loyaltyPurchase";

export default new Vuex.Store({
  modules: {
    auth,
    user,
    customer,
    product,
    order,
    retur,
    termofservice,
    alert,
    category,
    orderdisplay,
    principal,
    brand,
    branch,
    promo,
    paymentType,
    banner,
    ppn,
    customerNew,
    conversionPoint,
    loyaltyItem,
    area,
    pushcartProduct,
    resetPassword,
    report,
    shoppingCart,
    loyaltyPurchase
  }
});
